import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { CloudUpload } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { withAreaGetter } from 'providers/AreasConsumers';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { useEntityImport } from './hooks';

const ImportAction = ({ type, redirectUrl, getElemByAreaKey }) => {
  const { t } = useTranslation();
  const importFileRef = useRef();

  const { importing, importEntityFromFile } = useEntityImport(type, redirectUrl);

  const triggerFileImport = useCallback(() => {
    importFileRef.current.value = '';
    importFileRef.current.click();
  }, []);

  return (
    <>
      <input type='file' hidden ref={importFileRef} onChange={importEntityFromFile} />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <IconButton fontSize='medium' color='transparent' tooltip={t('Transfer.Import')} onClick={triggerFileImport} disabled={importing}>
          <CloudUpload />
        </IconButton>
      </Portal>
    </>
  );
};

ImportAction.propTypes = {
  type: PropTypes.string,
  redirectUrl: PropTypes.string,
  getElemByAreaKey: PropTypes.func
};

export default withAreaGetter(ImportAction);
